import React from 'react'
import AccountSettingSidebar from './components/AccountSettingSidebar'
import SurveyListHeader from '../../../component/layout/MainHeader'
import SurveyListSidebar from '../../../component/layout/MainSidebar'
import Svg from '../../../component/Svg'
import Switch from '../../../core/Switch'
import { Link } from 'react-router-dom'
import NestedMenuToggle from './NestedMenuToggle'

export default function Notifications() {
    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper main-site-wrapper'>
                <SurveyListHeader />
                <div id="viewport" className="d-flex">
                    <SurveyListSidebar />
                    <div className="flex-grow-1 d-flex">
                        <AccountSettingSidebar />
                        <div className="flex-grow-1 variable-pg-content">
                            {/* breadcrumbs here */}
                            <div className="custom-breadcrumb">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/admin/roi" className="home-item" title="Dashboard">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/admin/settings/profile">Settings</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            <strong>Notifications Settings</strong>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            {/* breadcrumbs ends here */}
                            <div className="survey-main-container">
                                <div className="page-heading d-lg-none">
                                    <div className="d-flex align-items-start">
                                        <NestedMenuToggle />
                                        <div className="flex-grow-1 ps-3 ps-lg-0">
                                            <h1>Notifications Settings</h1>
                                        </div>
                                    </div>
                                </div>
                                <div className="pagesRow varPg">
                                    <div className="profile-wrapper">
                                        <div className="main-form-wrapper notification-setting">
                                            <div className="field-wrapper d-flex justify-content-between align-items-center">
                                                <div className="small-heading">
                                                    <h6 className='mb-0'>Default</h6>
                                                </div>
                                                <div className="switch-wrap">
                                                    < Switch
                                                        type='def'
                                                        color='default'
                                                        checked={true}
                                                        disabled={false}
                                                        fill={false}
                                                        rtl={false}
                                                        leftPosition={false}
                                                        className='SwitchCustom'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
